import { combineReducers } from "redux";

import LayoutReducer from "./layout/reducer"

import LoginReducer from "./login/reducer"

import AccountReducer from "./register/reducer";

const rootReducer = combineReducers({
    Layout: LayoutReducer,
    Login: LoginReducer,
    Account: AccountReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;